export const PASSWORD_SPECIAL_CHAR_REGEX = /[!@#$%^&*/\\(),.><':;|_~`=[\]{}"?+-]/;

export const AUTH_FORM_VALIDATION = {
  // Email validation messages
  EMAIL_REQUIRED: 'Email address is required.',
  EMAIL_INVALID: 'Please enter a valid email address.',
  // Password validation messages
  PASSWORD_REQUIRED: 'Password is required.',
  PASSWORD_MIN: 'Password must be at least 8 characters.',
  PASSWORD_MAX: 'Password must be at less than 50 characters.',
  PASSWORD_NUMERIC: 'Password must includes a number.',
  PASSWORD_SYMBOL: 'Password must includes a symbol.',
  PASSWORD_UPPERCASE: 'Password must include an uppercase letter.',
  PASSWORD_LOWERCASE: 'Password must include a lowercase letter.',
  PASSWORD_NO_SPACES: 'Password must not contain spaces.',
  NEW_PASSWORD_REQUIRED: 'New password is required.',
  CONFIRM_PASSWORD_REQUIRED: 'Please confirm your password.',
  CONFIRM_PASSWORD_NOT_MATCH: 'Passwords must match.',
};

export const LOGIN_PAGE = {
  TITLE: 'Sign in to your account',
  SUBMIT_LABEL: 'Log in',
  LINK_LABEL: 'Forgot Password',
  SUCCESS_MESSAGE: 'Login successful. Redirecting to dashboard...',
  ERROR_MESSAGE: 'Incorrect email or password. Please try again.',
  ERROR_SOMETHING_WENT_WRONG: 'Something went wrong. Please try again.',
  SESSION_EXPIRED_MESSAGE: 'Session expired. Please log in again.',
  UNAUTHORIZED_ACCESS_MESSAGE:
    'This account is not authorized to access this portal. Please sign in with an authorized account.',
};

export const AUTH_RATE_LIMIT_MESSAGE = "You've made too many attempts. Please wait and try again.";

export const FORGOT_PASSWORD_PAGE = {
  TITLE: 'Reset your password',
  SUBMIT_LABEL: 'Send Reset Link',
  LINK_LABEL: 'Back to Login',
  SUCCESS_MESSAGE:
    'A password reset link has been sent to your email. Please check your inbox and follow the instructions to reset your password.',
  ERROR_MESSAGE: 'Something went wrong. Please try again.',
};

export const VERIFY_PAGE = {
  TITLE: 'Reset your password',
  SUBMIT_LABEL: 'Send Reset Link',
  LINK_LABEL: 'Back to Login',
  VERIFY_ERROR_MESSAGE:
    'Your password reset link has expired. Please request a new one to reset your password.',
  SUCCESS_MESSAGE:
    'A password reset link has been sent to your email. Please check your inbox and follow the instructions to reset your password.',
  ERROR_MESSAGE:
    'The email address you entered does not exist. Please check for any typos or try again.',
};

export const RESET_PASSWORD_PAGE = {
  TITLE: 'Reset your password',
  SUBMIT_LABEL: 'Reset Password',
  LINK_LABEL: 'Back to Login',
  SUCCESS_MESSAGE: 'Your password has been updated. Please log in with your new password.',
  ERROR_MESSAGE: 'Something went wrong. Please try again later.',
};

export const EMAIL_VERIFICATION_PAGE = {
  TITLE: 'Email Verification',
  SUBMIT_LABEL: 'Reset Password',
  LINK_LABEL: 'Back to Login',
};

export const SET_PASSWORD_PAGE = {
  TITLE: 'Set New Password',
  DESCRIPTION: 'For security reasons, please set a new password to continue.',
  SUBMIT_LABEL: 'Update Password',
  LINK_LABEL: 'Back to Login',
  SESSION_EXPIRED_MESSAGE: 'Your session has expired. Please log in and try again.',
};

export const MFA_PAGE = {
  TITLE: 'Confirm your account',
  SUBMIT_LABEL: 'Submit',
  LINK_LABEL: 'Back to Login',
};

export const SMS_MFA_PAGE = {
  TITLE: 'Confirm your account',
  SUBMIT_LABEL: 'Submit',
  LINK_LABEL: 'Back to Login',
};
